module.exports = {
      id: "pen-usage",
      viewBox: "0 0 20 20",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#pen",
      toString: function () {
        return this.url;
      }
    }